import { Box, FormControlLabel, Switch, Typography } from '@mui/material';
import { useState } from 'react';

import { useUpdatePiecesMutation } from '@api/piece';
import { PieceAction } from '@apiContract';
import { DialogConfirmation } from '@uiKit/DialogConfirmation';

import { ActionComponentProps } from '../../index';
import { buildUpdatePiecesRequest } from './helper';

export const RequestShred = ({ mailpieces, actionStarted, onActionFinish, isForce }: ActionComponentProps) => {
  const [updatePieces, { isLoading }] = useUpdatePiecesMutation();
  const [shouldNotify, setShouldNotify] = useState(true);

  const confirmAction = async () => {
    const requestData = buildUpdatePiecesRequest({
      mailpieces,
      action: PieceAction.RequestShred,
      isForce,
      shouldNotify,
    });

    await updatePieces(requestData).unwrap();

    onActionFinish();
  };

  const content = (
    <Box>
      <Typography variant="body1" color="text.secondary">
        {mailpieces.length === 1 ? (
          'Are you sure you would like this item to be shredded?'
        ) : (
          <>
            Are you sure you would like <strong>{mailpieces.length}</strong> items to be shredded?
          </>
        )}
      </Typography>

      {isForce && (
        <FormControlLabel
          control={<Switch />}
          sx={{ mt: 3 }}
          checked={shouldNotify}
          onChange={() => setShouldNotify(!shouldNotify)}
          label="Notify Mailroom"
        />
      )}
    </Box>
  );

  return (
    <DialogConfirmation
      open={actionStarted}
      loading={isLoading}
      maxWidth="xs"
      title={mailpieces.length === 1 ? 'Request shred' : 'Request shred for selected items'}
      content={content}
      acceptButtonHandleClick={confirmAction}
      cancelButtonHandleClick={onActionFinish}
      acceptButtonTitle="Submit"
      cancelButtonTitle="Cancel"
    />
  );
};
